import React from 'react';

import AuthHeader from '@cloud-ui/components/AuthHeader';
import { LicenseBanner } from '@cloud-ui/components/LicenseBanner';
import Navigation from '@cloud-ui/components/Navigation';
import { CliLoginDialogProvider } from '@cloud-ui/contexts/CliLoginDialogContext';
import { useThemePreference } from '@cloud-ui/hooks/useThemePreference';

import { useLocation } from 'react-router-dom';

import PHProvider from './posthog/PostHogProvider';
import PostHogPageView from './posthog/posthogPageviews';
import './PageShell.css';

// Routes that should use minimal auth header instead of full Navigation
// Note: /logout and /auth/fusionauth/callback redirect immediately so header barely shows
// /not-found is excluded - unauthenticated users should still see navigation for home link
const AUTH_ROUTES = [
  '/login',
  '/register',
  '/logout',
  '/auth/fusionauth/callback',
  '/upgrade',
  '/code-scan/setup',
];

export default function PageShell({ children }: { children: React.ReactNode }) {
  const { setThemePreference, systemTheme, themePreference } = useThemePreference();
  const location = useLocation();

  const isAuthRoute = AUTH_ROUTES.includes(location.pathname);
  const themeSelectorProps = {
    themePreference,
    systemTheme,
    onThemePreferenceChange: setThemePreference,
  };

  return (
    <CliLoginDialogProvider>
      <PHProvider>
        {isAuthRoute ? (
          <AuthHeader {...themeSelectorProps} />
        ) : (
          <Navigation {...themeSelectorProps} />
        )}
        {!isAuthRoute && <LicenseBanner />}
        <div className={`page-content ${isAuthRoute ? 'auth-page' : ''} flex flex-col min-h-0`}>
          {children}
        </div>
        <PostHogPageView />
      </PHProvider>
    </CliLoginDialogProvider>
  );
}
